const ResourceData = [
    
    {
    id: 1,
    resourceTitle: 'Admin',
    description: 'This is a special role, user has the potential to do a variety of activities on the dashboard',
    resourceUrl: 'This is a special role, user has the potential to do a variety of activities on the dashboard',
},

{
    id: 2,
    resourceTitle: 'Basic user',
    description: 'This is the default role every user starts with',
    resourceUrl: 'This is the default role every user starts with',
    
},

{
    id: 3,
    resourceTitle: 'Category Editor',
    description: 'This is the default role every user starts with',
    resourceUrl: 'This user is saddled with the ability to edit categories',
    
},

]

export {ResourceData}